{
  "cancel": {},
  "fail": {
    "back": {},
    "cancel": {},
    "tryAgain": {}
  },
  "placement": {},
  "report": {},
  "resource": {},
  "run": {},
  "score": {},
  "success": {
    "close": {}
  },
  "withResource": {}
}
